function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import styles from '@dtsl/css-help-button/dist/index.module.css';
import HelpCircle from '@dtsl/icons/dist/icons/react/HelpCircle';
import Info from '@dtsl/icons/dist/icons/react/Info';
import LightBulb from '@dtsl/icons/dist/icons/react/LightBulb';
const HELP_BUTTON_VARIANT = {
  HELP: 'help',
  INFO: 'info',
  TIP: 'tip'
};

// eslint-disable-next-line react/display-name
const HelpButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    variant,
    active,
    popoverData,
    hasPopover,
    onClick,
    ...restProps
  } = _ref;
  const helpButtonClasses = classNames({
    [styles['sib-help-btn']]: true,
    [styles[`sib-help-btn__${variant}`]]: !!variant,
    [styles[`sib-help-btn__active`]]: active,
    [styles['sib-btn']]: true,
    [styles['sib-btn_icon-stand-alone']]: true,
    [className]: !!className
  });
  const getIcon = () => {
    switch (variant) {
      case HELP_BUTTON_VARIANT.TIP:
        return /*#__PURE__*/React.createElement(LightBulb, {
          "aria-hidden": "true"
        });
      case HELP_BUTTON_VARIANT.INFO:
        return /*#__PURE__*/React.createElement(Info, {
          "aria-hidden": "true"
        });
      default:
        return /*#__PURE__*/React.createElement(HelpCircle, {
          "aria-hidden": "true"
        });
    }
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref,
    ariaLabel: "help button",
    onClick: onClick,
    hasPopover: hasPopover,
    popoverData: popoverData
  }, restProps, {
    iconAlone: true,
    icon: getIcon(),
    className: helpButtonClasses
  }));
});
HelpButton.defaultProps = {
  className: '',
  variant: 'help',
  disabled: false,
  active: false,
  hasPopover: false,
  popoverData: {},
  onClick: () => {}
};
HelpButton.propTypes = {
  variant: PropTypes.oneOf([HELP_BUTTON_VARIANT.HELP, HELP_BUTTON_VARIANT.INFO, HELP_BUTTON_VARIANT.TIP]),
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string,
  hasPopover: PropTypes.bool,
  popoverData: PropTypes.object,
  onClick: PropTypes.func
};
export default HelpButton;